import React from 'react';
import PayoutForm from '../../components/payout/PayoutForm';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {LoginWrapper} from '../../components';

const mapStateToProps = state => {
    return {
        userState: state.get('user').toJS()
    };
};

class PayoutView extends React.Component {
    static propTypes = {
        userState: PropTypes.object
    };

    render() {
        const { userState } = this.props;
        if (!userState.isLoggedIn) {
            return <LoginWrapper productName="fortnite" />;
        }

        return (
            <div className="payout-view">
                <PayoutForm hideTax={true} />
            </div>
        );
    }
}

export default connect(
    mapStateToProps
)(PayoutView);
